<template>
  <q-dialog v-model="dialog" persistent transition-show="fade" transition-hide="fade">
    <div class="hris-modal" style="max-width: 400px;">
      <div class="hris-modal-header">
        <div>
          <h2 class="hris-modal-title">Sign out</h2>
          <p class="hris-modal-subtitle" v-show="confirm">Are you sure you want to sign out of BeaPayDay?</p>
          <p class="hris-modal-subtitle" v-show="confirmedOut">Signing out…</p>
        </div>
      </div>
      <div class="hris-modal-footer" v-show="confirm">
        <q-btn unelevated class="hris-q-outline" label="Cancel" @click="closeDialog" />
        <q-btn unelevated class="hris-q-primary" label="Sign out" @click="onSubmit" />
      </div>
      <div class="hris-loading" v-show="confirmedOut">
        <q-spinner color="green" size="32px" />
        <span>Signing you out…</span>
      </div>
    </div>
  </q-dialog>
</template>
<script>
import vueCookies from 'vue-cookies';
export default {
  data() {
    return {
      dialog: false,
      confirm: true,
      confirmedOut: false
    }
  },
  created() {
    this.eventHub.$on('logOut', this.openDialog);
  },
  methods: {
    openDialog: function(payload) {
      this.dialog = payload.status
      this.routes = payload.routes
    },
    closeDialog: function() {
      this.dialog = false
    },
    onSubmit: function() {
      this.confirm = false;
      this.confirmedOut = true;
      vueCookies.remove(this.cookieKey);
      setTimeout(() => {
        location.reload();
        this.loading = false
      }, 1000);
    }
  }
}
</script>
<style lang="css" scoped>
</style>
